<template>
  <div id="api2Main" class="body" ref="body">
    <vue-snotify></vue-snotify>
      <div>
        <div>
          <div class="center-vertical">
            <div class="center-content row">
              <div class="center-margin">
                <form v-on:submit.prevent="tryLogin(login,password)"
                      id="formLogin">
                  <div class="" v-if="showWindow" part="login-window">
                    <!--                                        Login-->
                    <div class="content-box-wrapper" v-if="currentPage === 0">

                      <div class="form-group">
                        <label v-if="loginValidation === 'email'" for="login" style="weight: bold;"> Email: </label>
                        <label v-else for="login" style="weight: bold;"> Login:</label>
                        <div class="input-group input-group-lg">
                            <span class="input-group-addon addon-inside bg-white font-primary">
                                <i class="glyph-icon"
                                  :class="loginValidation === 'email' ? 'icon-envelope-o' : 'icon-user'"
                                ></i>
                            </span>
                          <input v-bind:type="loginValidation === 'email' ? 'email' : 'text'"
                                 v-model="login"
                                 id="login"
                                 class="form-control"
                                 v-bind:placeholder='loginValidation === "email" ? $t("message.enter_email") : $t("message.enter_login")'
                          >
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="password" style="weight: bold;">{{$t("message.password")}}:</label>
                        <div class="input-group input-group-lg" style="position:relative">
                            <span class="input-group-addon addon-inside bg-white font-primary">
                                <i class="glyph-icon icon-unlock-alt"></i>
                            </span>
                          <input :type="passwordType"
                                 class="form-control"
                                 id="password"
                                 v-model="password"
                                 v-bind:placeholder='$t("message.password")'
                          >
                          <button type="button" class="password-switch" v-if="passwordView" @click="switchPassword()"><i class="glyph-icon" v-bind:class="passwordType=='password' ? 'icon-eye' : 'icon-eye-slash'"></i></button>
                        </div>
                      </div>

                      <div class="form-group" style="text-align: right;">
                        <mlm-popover trigger="click" :options="{placement: 'auto'}"
                                     ref="mlmpc_password">
                          <span slot="header" class="pop-head">{{$t("message.forgot_your_password")}}</span>
                          <div slot="body" class="popup-body">


                            <template v-if="loginField === 'phone'">
                              <div class="form-group"  >
                                <label>Phone:</label>
                                <div class="input-group input-group-lg">
                                  <span class="input-group-addon addon-inside bg-white font-primary">
                                      <i class="glyph-icon icon-phone"></i>
                                  </span>
                                  <vue-tel-input mode="international"
                                                 :dropdownOptions="{ showFlags: true, showDialCodeInSelection: true, }"
                                                 valid-characters-only="true"
                                                 autoformat
                                                 id="phone"
                                                 v-model="confirmAvailibility.phoneField"
                                                 :readonly="confirmAvailibility.phone.phoneCodeSended"
                                  ></vue-tel-input>
                                </div>
                              </div>
                              <div class="fieldConfirmation" v-if="!confirmAvailibility.phone.phoneConfirmed">
                                <div v-if="!confirmAvailibility.phone.phoneCodeSended">
                                  <label>Confirm phone</label><br/>
                                  <div class="btn btn-default bootstrap-touchspin-up" @click="sendPhoneCodeRequest">{{ $t("message.send_code") }}</div>
                                </div>
                                <div v-else>
                                  <label>{{ $t("message.enter_code") }}</label> <br/>
                                  <input  class="form-control" style="display: inline-block; width: 200px;" v-model="confirmAvailibility.phone.phoneCode" />
                                  <div class="btn btn-default bootstrap-touchspin-up" style="display: inline-block; margin-left: 5px;" @click="sendPhoneCode">Ok</div>
                                </div>
                              </div>
                            </template>

                            <template v-if="loginField === 'email'">
                              <div class="form-group"  >
                                <label for="phone">Email:</label>
                                <div class="input-group input-group-lg">
                                  <span class="input-group-addon addon-inside bg-white font-primary">
                                      <i class="glyph-icon icon-envelope-o"></i>
                                  </span>
                                  <input type="text"
                                         class="form-control"
                                         v-model="confirmAvailibility.emailField"
                                         id="email"
                                         placeholder="Email"
                                         :readonly="confirmAvailibility.email.emailCodeSended"
                                  >
                                </div>
                              </div>
                              <div class="fieldConfirmation" v-if="!confirmAvailibility.email.emailConfirmed">
                                <div v-if="!confirmAvailibility.email.emailCodeSended">
                                  <label>{{ $t("message.confirm_email") }}</label><br/>
                                  <div class="btn btn-default bootstrap-touchspin-up" @click="sendEmailCodeRequest">{{ $t("message.send_code") }}</div>
                                </div>
                                <div v-else>
                                  <label>{{ $t("message.enter_code") }}</label> <br/>
                                  <input  class="form-control" style="display: inline-block; width: 200px;" v-model="confirmAvailibility.email.emailCode" />
                                  <div class="btn btn-default bootstrap-touchspin-up" style="display: inline-block; margin-left: 5px;" @click="sendEmailCode">Ok</div>
                                </div>
                              </div>
                            </template>
                            <template v-if="confirmAvailibility.couldChange">
                              <div class="form-group">
                                <label for="password">{{ $t("message.password") }}:</label>
                                <div class="input-group input-group-lg">
                                <span class="input-group-addon addon-inside bg-white font-primary">
                                    <i class="glyph-icon icon-unlock-alt"></i>
                                </span>
                                  <input type="password"
                                         class="form-control"
                                         id="newPassword1"
                                         :minlength="6"
                                         v-model="newPassword1"
                                         v-bind:placeholder='$t("message.password")'
                                  >
                                </div>
                              </div>
                              <div class="form-group">
                                <label for="password">{{ $t("message.password_confirm") }}:</label>
                                <div class="input-group input-group-lg">
                                <span class="input-group-addon addon-inside bg-white font-primary">
                                    <i class="glyph-icon icon-unlock-alt"></i>
                                </span>
                                  <input type="password"
                                         class="form-control"
                                         id="newPassword2"
                                         :minlength="6"
                                         v-model="newPassword2"
                                         v-bind:placeholder='$t("message.password")'
                                  >
                                </div>
                              </div>
                            </template>

                          </div>
                          <div slot="footer">
                                <div v-if="confirmAvailibility.couldChange" class="btn btn-primary btn-link" @click="changePassword">Ok</div>
                          </div>
                          <div slot="reference" v-if="!forgotView" id="id_b_password" ref="forgotLink" style="display: inline-block; color: #8da0aa; cursor: pointer;"
                                  class="canEdit control-label">{{$t("message.forgot_your_password")}}
                          </div>
                        </mlm-popover>
                      </div>
                      <div class="button-pane">
                        <button id="buttonLogin" type="submit" part="buttonLogin" class="btn btn-block btn-primary-custom">{{ $t("message.sign_in") }}</button>
                      </div>

                    </div>

                    <div class="content-box-wrapper" v-else-if="currentPage === 3">
                      <div class="form-group">
                        <label for="password1">{{$t('message.password')}}</label>
                        <div class="button-inside">
                          <input class="form-control" id="password1" v-model="confirmAvailibility.password1"
                                 :type="showPass1 ? 'text' : 'password'" required
                                 :minlength="passwordLength||6">
                          <div class="button-pass" @click.prevent="showPass1=!showPass1">
                            <font-awesome-icon :icon="showPass1 ? 'eye' : 'eye-slash'"
                                               class="faw"/>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="password2">{{$t('message.password_confirm')}}</label>
                        <div class="button-inside">
                          <input class="form-control" id="password2" v-model="confirmAvailibility.password2"
                                 :type="showPass2 ? 'text' : 'password'" required
                                 :minlength="passwordLength||6"
                                 v-bind:style="((p1L>(passwordLength-1||5)) && (password1===password2)) ? {'border-color': 'green'}: ((p2L>(passwordLength-1||5)) ? {'border-color': 'red'} : {}) ">
                          <div class="button-pass" @click.prevent="showPass2=!showPass2">
                            <font-awesome-icon :icon="showPass2 ? 'eye' : 'eye-slash'"
                                               class="faw"/>
                          </div>
                        </div>
                      </div>
                      <button id="buttonConfirmPass" type="submit"
                              class="btn btn-success btn-block"
                              :disabled="isLoading || (password1!==password2 && p1L>(passwordLength-1||5) && p2L>(passwordLength-1||5))">
                        <span v-if="isLoading" class="loading"></span>
                        <span class="mr-1" v-if="!isLoading"><font-awesome-icon
                            icon="sign-in-alt" class="faw"/></span><span
                          v-if="!isLoading">{{ $t("message.sign_in") }}</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import MLMSoftUICore from '../api2_middleware/MLMSoftUICore'
// noinspection SpellCheckingInspection
import Snotify from 'vue-snotify'
import Vuetify from 'vuetify/lib'
import mlmPopover from '../../nested_components/mlm_popover/Popover'
import VueTelInput from 'vue-tel-input'
//import CryptoJS from 'crypto-js/crypto-js'
// noinspection ES6CheckImport
import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {
  faTimes,
  faCog,
  faEnvelope,
  faUnlockAlt,
  faSpinner,
  faExclamationCircle,
  faSignInAlt,
  faEye,
  faEyeSlash,
  faCalendarAlt,
  faUser
} from '@fortawesome/free-solid-svg-icons' //icon-cog, icon-envelope-o,icon-unlock-alt
library.add(faCog, faEnvelope, faUnlockAlt, faSpinner, faExclamationCircle, faSignInAlt, faEye, faEyeSlash, faCalendarAlt, faTimes, faUser);
if (!window.Vue.$_vuetify_installed)
  window.Vue.use(Vuetify);
window.Vue.use(VueTelInput)
// window.Vue.use(CryptoJS)

const sUi = MLMSoftUICore.instance;
const store = sUi.getStore();
const HTTPGlobalSettings = store.dispatch('request', {
  path: 'api2/main-app/setting/get-list?group=global',
  method: 'get',
  withoutCheckLogin: true,
});
const i18n = new window.VueI18n({
  locale: 'en-US', // set locale
  fallbackLocale: 'en-US',
  messages: {
    "en-US": {
      "message": {
        "sign_in": "Sign In",
        "forgot_your_password": "Forgot Your Password?",
        "login_to_your_account": "Login to your account.",
        "enter_email": "Enter email",
        "password": "Password",
        "members_area": "MEMBERS AREA",
        "invalid_username_or_password": "Invalid username or password",
        "registration": "Registration",
        "loading": "Loading",
        "enter": "Enter",
        "sponsor_id": "Sponsor ID",
        "register": "Register",
        "recovery_password": "Recovery password",
        "email_new_password": "E-Mail new password",
        "user_creation_error": "User creation error",
        "user_created": "User created",
        "error": "Error",
        "try_to_login": "Try to login and repeat request",
        "check_email": "Please check email to registration complete",
        "cant_create_user": "Can't create a user",
        "account_not_found": "Account not found with such referral code",
        "warning": "Warning",
        "create_password": "Create password",
        "password_confirm": "Confirm password",
        "password_created": "Password created",
        "cant_find_email": "Can't find email or email is incorrect",
        "you_login": "You can sign in using your new login and password",
        "enter_login": "Enter login",
        "please_select": "Please select",
        "check_email_after_registration": "Confirmation email is sent. Make sure you check your email spam and junk folders.",
        "mail_confirmed": "Mail confirmed",
        "mail_already_confirmed": "E-mail already confirmed",
        "wrong_confirmation_code": "Wrong confirmation code",
        "dont_know_sponsor": "I don't know sponsor ID",
        "confirm_email": "Confirm email",
        "send_code": "Send code",
        "enter_code": "Enter code",
        "confirm_phone": "Confirm phone",
        "code_was_send_phone": "Code was send to you phone, please check",
        "code_was_send_email": "Code was send to you email, please check",
        "phone_confirmation": "Phone confirmation",
        "email_confirmation": "Email confirmation",
        "code_confirmed": "Code confirmed",
        "wrong_code": "Wrong code",
        "please_confirm_phone": "Please, confirm phone",
        "please_confirm_email": "Please, confirm email",
        "next": "Next",
        "back": "Back",
        "same_password": "Password should be the same",
        "password_min": "Password should be 6 symbols min",
        "password_changed": "Password changed"
      }
    },
  }

});
const keyCodes = {
  windows: {
    "backspace": 8,
    "tab": 9,
    "enter": 13,
    "left arrow": 37,
    "right arrow": 39,
    "delete": 46,
    "period": 190,
    "0": 48,
    "9": 57,
    "num 0": 96,
    "num 9": 105,
    "num period": 110,
    "input busy": 229
  }
};
const languageDescriptins = new Map([['en-us', 'English'], ['ru-ru', 'Русский'], ['bg-bg', 'Български'], ['es', 'Español'], ['fr', 'Français'], ['de-de', 'Deutsch']]);
//let listener = sUi.setListenerToLocale('Api2Middleware', i18n);
export default {
  name: 'api2-middleware',
  components: {
    FontAwesomeIcon,
    mlmPopover,
  },
  vuetify: new Vuetify({
    icons: {
      iconfont: 'mdiSvg' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
    }
  }),
  i18n: i18n,
  mixins: [Snotify],
  props: {
    loginField: {
      type: String,
      default: 'email',
    },
    registrationHtml: {
      type: String,
      default: ''
    },
    companyLogo: {
      type: String,
      default: ''
    },
    customLocalization: {
      type: String,
      default: ''
    },
    disableAccess: {
      type: String,
      default: ''
    },
    loginValidation: {
      type: String,
      default: 'email'
    },
    fontFamilyRe: {
      type: String,
      default: null,
      required: false
    },
    registrationType: { //0-open 1-referral 2-close
      required: false,
      default: 0,
      type: Number
    },
    allLanguages: {
      required: false,
      default: '["en-US","ru-RU"]',
      type: String
    },
    feedGroupNumber: {
      required: false,
      type: String
    },
    feedUrl: {
      required: false,
      type: String
    },
    xDomain: {
      required: false,
      type: String
    },
    thousandDelimeter: {
      default: ',',
      required: false,
      type: String
    },
    defaultLocalization: {
      default: 'en-US',
      required: false,
      type: String
    },
    freezeLocale: {
      default: false,
      required: false,
      type: Boolean
    },
    passwordView: {
      default: false,
      required: false,
      type: Boolean
    },
    forgotView: {
      default: false,
      required: false,
      type: Boolean
    },
    passwordLength: {
      default: 6,
      required: false,
      type: Number
    },
    accountTemplates: {
      default: '[]',
      required: false,
      type: String
    },
    registrationFields: {
      default: '[]',
      required: false,
      type: String
    },
    setOnRegister: {
      default: '[]',
      required: false,
      type: String
    },
    accountMask: {
      default: '0000 0000 0000',
      required: false,
      type: String
    },
    firstCountry: {
      required: false,
      type: String
    }
  },
  data: function () {
    return {
      showWindow: false,
      sponsorName: null,
      country_and_regionRequired: false,
      xd_cookie: null,
      currentPage: 0,
      isLoading: false,
      loadingRegistration: false,
      refId: null,
      currentRefId: null,
      email: '',
      login: '',
      password: '',
      passwordType: 'password',
      loginBackImg: '',
      countryRegionList: [],
      currentCountry: null,
      currentRegion: null,
      registrationParams: null,
      // setOnRegister_: null,
      password1: '',
      password2: '',
      showPass1: false,
      showPass2: false,
      registrationMethod: null, //0 - auto 1 - by user
      enrollWithoutSponsor: false,
      loginType: null,
      hideLogin: false,
      resetPassCodeConfirm: '',
      newPassword1: '',
      newPassword2: '',
      confirmAvailibility: {
        phone: {
          phoneCodeSended: false,
          phoneCode: '',
          phoneConfirmed: false,
          requestId: '',
        },
        email: {
          emailCodeSended: false,
          emailCode: '',
          emailConfirmed: false,
          requestId: '',
        },
        loginField: '',
        emailField: '',
        phoneField: '',
        password1: '',
        password2: '',
        couldChange: false,
      },
    }
  },
  created: async function () {
    store.commit('localeFromStorage', {
      defaultLocale: this.defaultLocalization || 'en-US',
      freezeLocale: this.freezeLocale
    });
    if (localStorage.getItem("page") !== null) {
      const currentPageFromStorage = parseInt(sessionStorage.getItem('page'));
      const registrationsTypeFromStorage = parseInt(sessionStorage.getItem('regtype'));
      if (currentPageFromStorage !== null && !isNaN(currentPageFromStorage) && currentPageFromStorage != undefined) {
        if (currentPageFromStorage === 1) {
          this.registrationType = registrationsTypeFromStorage
        }
        this.currentPage = currentPageFromStorage
      }
      sessionStorage.removeItem('page');
      sessionStorage.removeItem('regtype');
    }
    if (this.fontFamilyRe)
      store.commit('setFontFamilyRe', this.fontFamilyRe);
    if (this.feedGroupNumber != null)
      store.commit('setFeedGroupNumber', this.feedGroupNumber || 0);
    this.xd_cookie = (this.xDomain && window.xDomainCookie) ? window.xDomainCookie(this.xDomain, "my.namespace", true, undefined, true) : null;
    if (this.xd_cookie) {
      const t = localStorage.getItem('user-token');
      const rt = localStorage.getItem('user-refresh-token');
      const getCookiesPromise = new Promise((resolve, reject) => {
        this.xd_cookie.get('tkns', function (cookie_val) {
          // cookie val will contain value of cookie as fetched from local val (if present) else from iframe (if set), else null
          try {
            if (!cookie_val) {
              if (t && rt)
                store.commit('setTokensToStorage', {
                  accessToken: null,
                  refreshToken: null
                });
            } else {
              const cookie_val_obj = JSON.parse(cookie_val);
              if(localStorage.getItem('logout') !== '1') {
                store.commit('setTokensToStorage', {
                  accessToken: cookie_val_obj.ut,
                  refreshToken: cookie_val_obj.urt
                });
                store.commit('setIsLoggedIn', true);
              }
            }
            resolve();
          } catch (e) {
            reject(e);
          }

        });
      });
      await getCookiesPromise;
      localStorage.setItem('logout', '0');
    }
    store.commit('getTokensFromStorage');
    if(store?.state?.isLoggedIn) {
      window.location.replace('/')
    } else {
      this.showWindow = true;
    }
    // store.commit('getApi3TokensFromStorage');
    const fullPath = new URL(window.location.href);


    this.postCreate();
    const email_code_confirm = fullPath.searchParams.get('email_code_confirm');

    if(email_code_confirm) {
      await this.checkEmailConfirmation()
    }
    const page_flag = fullPath.searchParams.get('page');
    if(page_flag === 'registration') {
      this.registrationType = 0
      this.currentPage = 1
    }
  },
  computed: {
    regHtml() {
      if (!this.registrationHtml)
        return '';
      try {
        const parsedRH = JSON.parse(this.registrationHtml);
        if (Array.isArray(parsedRH)) {
          const foundItem = parsedRH.find(item => {
            const si = item.split('=');
            if (si.length<2)
              return false;
            return si[0].toString().trim().toLowerCase() === this.locale.toLowerCase();
          })
          if (foundItem)
            return foundItem.split('=').slice(1).join('=').trim();
          return '';
        }
      } catch (e) {
        console.error(e);
      }
      return '';
    },
    showRegistrationPage() {
      return this.registrationType === 0 || (this.refId != null && this.registrationType <= 1);
    },
    getAllLanguages() {
      let at;
      try {
        at = JSON.parse(this.allLanguages);
        if (!Array.isArray(at))
          at = [];
      } catch (e) {
        at = ['en-US'];
      }
      return at;
    },
    hrefEn() {
      return window.location.href.replace(/en-us/ig, 'ru-RU');
    },
    p1L() {
      return this.password1.length;
    },
    p2L() {
      return this.password2.length;
    },
    showLogin() {
      return !store.state.isLoggedIn;
    },
    locale() {
      return store.state.locale;
    },
    tokensSSO() {
      return store.getters.tokensSSO;
    }
  },
  watch: {
    refId(newValue) {
      if (!newValue) {
        this.sponsorName = null;
        return;
      }
      const that = this;
      store.dispatch('request', {
        path: 'api2/main-app/account/get-fullname-from-id?id=' + this.refId,
        method: 'get',
        withoutCheckLogin: true
      }).then(response => {
        if (!that.refId)
          throw 'refId is nulled';
        if (response.data.errorCode === 0) {
          const list = response['data']['primary']['payload']['list'];
          if (!list)
            throw 'list is null';
          that.sponsorName = list[that.refId]['p.'].firstname.value + ' ' + list[that.refId]['p.'].lastname.value;
        }}).
      catch( function () {
        that.sponsorName = null;
      })
    },
    tokensSSO(newValue) {
      if (!this.xd_cookie)
        return;
      if (newValue && newValue.accessToken && newValue.refreshToken)
        this.xd_cookie.set('tkns', JSON.stringify({
          "ut": newValue.accessToken,
          "urt": newValue.refreshToken
        }));
      else this.xd_cookie.set('tkns', 'false');
    },
    showLogin(newValue) {
      if (newValue) {
        window.dispatchEvent(new CustomEvent('showLoginForm'));
        if (this.loginValidation === 'id')
          this.idFromStorage();
        //this.getCredentialsFromCode();
        this.toggleBodyClass('addClass', 'modal-open');
        if (this.xd_cookie)
          this.xd_cookie.set('tkns', 'false');
      } else {
        window.dispatchEvent(new CustomEvent('hideLoginForm'));
        if (this.loginValidation === 'id')
          this.idToStorage();
        this.toggleBodyClass('removeClass', 'modal-open');
      }
    },
    locale(newLocale) {
      i18n.locale = newLocale;
      this.$vuetify.lang.current = newLocale;
    },
    currentPage(newValue) {
      if ((newValue === 1) && (!this.registrationParams))
        this.getRegistrationFields();
    }
  },
  methods: {


    // ------ Fields confirmation block
    async sendPhoneCodeRequest() {
      let sendRequest = await store.dispatch('sendCheckPhone', this.confirmAvailibility.phoneField);
      if(sendRequest?.result === 'ok') {
        store.dispatch('showToast', {
          title: this.$t('message.phone_confirmation'),
          body: this.$t('message.code_was_send_phone'),
          type: 'success',
          timeout: 7000
        });
        this.confirmAvailibility.phone.phoneCodeSended = true;
        this.confirmAvailibility.phone.requestId = sendRequest.requestId;
      } else {
        store.dispatch('showToast', {
          title: '',
          body: sendRequest.error,
          type: 'error',
          timeout: 7000
        });
      }
    },

    async sendPhoneCode() {
      let sendRequest = await store.dispatch('sendCheckPhoneCode',this.confirmAvailibility.phone.phoneCode);
      if(sendRequest === 'ok') {
        store.dispatch('showToast', {
          title: this.$t('message.phone_confirmation'),
          body: this.$t('message.code_confirmed'),
          type: 'success',
          timeout: 7000
        });
        this.confirmAvailibility.phone.phoneConfirmed = true;
        this.confirmAvailibility.couldChange = true;
      } else {
        store.dispatch('showToast', {
          title: '',
          body: this.$t('message.wrong_code'),
          type: 'error',
          timeout: 7000
        });
        this.confirmAvailibility.phone.phoneConfirmed = false;
        this.confirmAvailibility.phone.phoneCodeSended = false;
      }
    },

    async sendEmailCodeRequest() {

      let checkRequest = await store.dispatch('checkExistsEmail', this.confirmAvailibility.emailField.toLowerCase());
      if (checkRequest?.success && !checkRequest?.payload?.exists) {
        store.dispatch('showToast', {
          title: '',
          body: (/ru-RU/.test(window.location.href) 
            ? 'Введенный E-mail "' + this.confirmAvailibility.emailField + '" не найден'
            : 'Entered E-mail "' + this.confirmAvailibility.emailField + '" is not found'),
          type: 'error',
          timeout: 7000
        });
        return checkRequest
      }
      
      if (!checkRequest?.success) {
        store.dispatch('showToast', {
          title: '',
          body: checkRequest.error,
          type: 'error',
          timeout: 7000
        });

        return checkRequest
      }

      let sendRequest = await store.dispatch('sendCheckEmail', this.confirmAvailibility.emailField.toLowerCase());
      if(sendRequest?.result === 'ok') {
        store.dispatch('showToast', {
          title: this.$t('message.email_confirmation'),
          body: this.$t('message.code_was_send_email'),
          type: 'success',
          timeout: 7000
        });
        this.confirmAvailibility.email.emailCodeSended = true;
        this.confirmAvailibility.email.requestId = sendRequest.requestId;
      } else {
        store.dispatch('showToast', {
          title: '',
          body: sendRequest.error,
          type: 'error',
          timeout: 7000
        });
      }
    },

    async sendEmailCode() {
      let sendRequest = await store.dispatch('sendCheckEmailCode',this.confirmAvailibility.email.emailCode);
      if(sendRequest === 'ok') {
        store.dispatch('showToast', {
          title: this.$t('message.email_confirmation'),
          body: this.$t('message.code_confirmed'),
          type: 'success',
          timeout: 7000
        });
        this.confirmAvailibility.email.emailConfirmed = true;
        this.confirmAvailibility.couldChange = true;
      } else {
        store.dispatch('showToast', {
          title: '',
          body: this.$t('message.wrong_code'),
          type: 'error',
          timeout: 7000
        });
        this.confirmAvailibility.email.emailConfirmed = false;
        this.confirmAvailibility.email.emailCodeSended = false;
      }
    },

    async changePassword() {
      if(this.newPassword1 != this.newPassword2) {
        store.dispatch('showToast', {
          title: '',
          body: this.$t('message.same_password'),
          type: 'error',
          timeout: 7000
        });
        return;
      }
      if(this.newPassword1.length < 6) {
        store.dispatch('showToast', {
          title: '',
          body: this.$t('message.password_min'),
          type: 'error',
          timeout: 7000
        });
        return;
      }
      const changePassParams = {
        email: this.loginField === 'email' ? this.confirmAvailibility.emailField.toLowerCase() : null,
        phone: this.loginField === 'phone' ? this.confirmAvailibility.phoneField : null,
        password: this.newPassword1
      }
      let otpCheck = '';
      if(this.loginField === 'email') {
        otpCheck += 'email_confirm:' + this.confirmAvailibility.email.requestId + ':' + this.confirmAvailibility.email.emailCode;
      }
      if(this.loginField === 'phone') {
        otpCheck += 'email_confirm:' + this.confirmAvailibility.phone.requestId + ':' + this.confirmAvailibility.phone.phoneCode;
      }
      store.dispatch('writeOtpCheck', otpCheck)


      const sendRequest = await store.dispatch('changePassword', changePassParams);
      console.log(sendRequest)
      if(sendRequest === 'ok') {
        this.confirmAvailibility.couldChange = false
        store.dispatch('showToast', {
          title: '',
          body: this.$t('message.password_changed'),
          type: 'success',
          timeout: 7000
        });

        console.log('this.loginField', this.loginField)
        console.log('this.confirmAvailibility.', this.confirmAvailibility)
        if(this.loginField === 'email') {this.login = this.confirmAvailibility.emailField; }
        if(this.loginField === 'phone') {this.login = this.confirmAvailibility.phoneField; }
        this.password = this.password1;
        this.$refs.forgotLink.click()
      }
    },
    switchPassword(){
      this.passwordType = this.passwordType == 'password' ? 'text' : 'password';
    },

    // ------


    idToStorage() {
      store.dispatch('getAccountId').then(aid => localStorage.setItem('IdLogin', aid || '')).catch(() => localStorage.removeItem('IdLogin'))
    },
    idFromStorage() {
      this.login = localStorage.getItem('IdLogin' || '')
    },
    getLanguageDescription(lang) {
      return languageDescriptins.get(lang.toLowerCase()) || lang;
    },
    hrefLang(lang) {
      sessionStorage.setItem('page', this.currentPage.toString())
      sessionStorage.setItem('regtype', this.registrationType.toString())
      const re = new RegExp(this.getAllLanguages.join('|'), 'ig');
      return window.location.href.replace(re, lang);
    },
    postCreate() {
      if (this.disableAccess != null && this.disableAccess.trim()){
        this.currentPage = 4;
        store.dispatch('logout');
      }
      store.dispatch('getLocalizationModule', {module: 'Api2Middleware', i18n: i18n, customLocalization: this.customLocalization});
      store.commit('setToastFunction', this.showToast);
      let at;
      try {
        at = JSON.parse(this.accountTemplates);
        if (!Array.isArray(at))
          at = [];
      } catch (e) {
        at = [];
      }
      at.length && store.commit('setAccountTemplate', at);
      MLMSoftUICore.setThousandDelimeter(this.thousandDelimeter);
      MLMSoftUICore.setAccountMask(this.accountMask);
      window.MLMSoftUICore = MLMSoftUICore;
      store.commit('setPaymentStackFromStorage');
      window.dispatchEvent(new CustomEvent('singletonCreated'));
      this.getPayResultFromCode();
      this.getCredentialsFromCode(!this.showLogin)
    },
    toggleBodyClass(addRemoveClass, className) {
      this.$nextTick(() => {
        const el = document.body;

        if (addRemoveClass === 'addClass') {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      });

    },
    //get sponsor id from ref code in path /?ref=code
    async getSponsorFromRef() {
      if (this.registrationType === 2)
        return false;
      try {
        const fullPath = new URL(window.location.href);
        const ref = fullPath.searchParams.get('ref');
        //get refId from refCode
        if (!ref)
          return false;
        this.currentPage = -1;
        await store.dispatch('request', {
          path: 'api2/main-app/account/search-by-invite?inviteCode=' + encodeURIComponent(ref),
          method: 'get',
          withoutCheckLogin: true
        }).then(response => {
          if (response.data.errorCode === 0) {
            const refAccount = response['data']['primary']['payload']['account'];
            if (!refAccount)
              throw this.$t('message.account_not_found');
            this.refId = refAccount.id;
            this.currentRefId = this.refId;
          } else
            throw response.data.errorMessage;
        }).catch(e => {
          throw e;
        });
        this.currentPage = 1;
      } catch (e) {
        store.dispatch('showToast', {
          title: this.$t('message.warning'),
          body: (e && e.response && e.response.data && (typeof e.response.data === 'string')) ? e.response.data : this.$t('message.account_not_found'),
          type: 'warning',
          timeout: 7000
        });
        this.currentPage = 1;
      }
    },

    async checkEmailConfirmation() {
      const fullPath = new URL(window.location.href);
      const emailConfirmationCode = fullPath.searchParams.get('email_code_confirm');
      if (!emailConfirmationCode)
        return false;
      await store.dispatch('request', {
        path: 'api2/main-app/user/mail-confirm',
        method: 'post',
        params_: {
          "code": encodeURIComponent(emailConfirmationCode),
        },
        withoutCheckLogin: true
      }).then(response => {
        if (response.data.errorCode === 0) {
          const checkEmailCodeResult = response['data']['primary']['success'];
          if (checkEmailCodeResult) {
            store.dispatch('showToast', {
              title: this.$t('message.mail_confirmed'),
              body: this.$t('message.mail_confirmed'),
              type: 'success',
              timeout: 7000
            });
          }
        }
      }).catch(e => {
        if(e.response.data.errorCode === 3601) {
          store.dispatch('showToast', {
            title: this.$t('message.warning'),
            body: this.$t('message.mail_already_confirmed'),
            type: 'error',
            timeout: 7000
          });
        }
        if(e.response.data.errorCode === 3600) {
          store.dispatch('showToast', {
            title: this.$t('message.warning'),
            body: this.$t('message.wrong_confirmation_code'),
            type: 'error',
            timeout: 7000
          });
        }
      });
    },

    getPayResultFromCode() {
      const fullPath = new URL(window.location.href);
      const payId = fullPath.searchParams.get('checkPay');
      if (payId)
        store.dispatch('payResult', payId);
    },

    getCredentialsFromCode(onlyConfirm = false) {
      try {
        const fullPath = new URL(window.location.href);
        const code_confirm = fullPath.searchParams.get('code_confirm');
        // const email_code_confirm = fullPath.searchParams.get('email_code_confirm');
        // if(email_code_confirm) {
        //     this.checkEmailConfirmation()
        // }
        //get credentials from code_confirm
        if (!code_confirm) {
          if (onlyConfirm)
            return false;
          this.getSponsorFromRef();
          return false;
        }
        if (!onlyConfirm)
          this.currentPage = -1;
        HTTPGlobalSettings.then(response => {
          if (response.data.errorCode === 0) {
            try {
              this.registrationMethod = response['data']['primary']['payload']['settings']['passwordCreationType'];
              if (onlyConfirm && !this.registrationMethod)
                return false
              this.loginType = response['data']['primary']['payload']['settings']['loginType'];


              store.dispatch('request', {
                path: 'api2/main-app/user/mail-confirm',
                method: 'post',
                params_: {
                  "code": encodeURIComponent(code_confirm),
                  "setConfirmed": false
                },
                withoutCheckLogin: true
              }).then(() => {
                // if (!this.registrationMethod)
                this.currentPage = 3;
                // else {
                //   store.dispatch('moveNewTokensToStorage');
                //   this.currentPage = 0;
                // }
              }).catch(e => {
                store.dispatch('showToast', {
                  title: 'mail',
                  body: e.response.data.errorMessage,
                  type: 'error',
                  timeout: 7000
                });
                this.isLoading = false;
                this.currentPage = 0;
              });
            } catch (e) {
              if (!onlyConfirm){
                this.currentPage = 1;
                this.registrationMethod = 0;
                this.loginType = 1;
              }
            }
          } else {
            if (!onlyConfirm){
              this.currentPage = 1;
              this.registrationMethod = 0;
              this.loginType = 1;
            }
          }
        }).catch(function () {
              if (!onlyConfirm){
                this.currentPage = 1;
                this.registrationMethod = 0;
                this.loginType = 1;
              }
            }
        );
      } catch (e) {
        this.currentPage = 1;
      }
    },

    showToast: function (title, body, type, timeout) {
      if(timeout === undefined) {
        timeout = 2000
      }
      this.$snotify.create({title: title, body: body, config: {type: type, titleMaxLength: 100, timeout: timeout }});
    },

    tryLogin: function (m, p) {

      if (this.loginValidation === 'id')
        m = Math.abs(parseInt(m.toString().replace(/\s/g, ''))).toString();
      this.isLoading = true;


      store.dispatch('login', {m: m.toString().toLowerCase(), p: p}).then(response => {
        this.isLoading = false;
        if (response !== 'ok') {
          store.dispatch('showToast', {
            title: '',
            body: response || this.$t('message.invalid_username_or_password'),
            type: 'error',
            timeout: 7000
          });
        } else if (response === 'ok') {
          this.$emit('loginDone');

          const fullPath = new URL(window.location.href);
          let redirect   = ''
          redirect       = fullPath.searchParams.get('redirect');
          if(redirect && redirect?.length > 2) {
            window.location.replace(redirect);
          } else {
            window.location.replace('/');
          }
        } else {
          console.log('response 3', response)
          console.log('response?.data 3', response?.data)
          console.log('response?.data?.success 3', response?.data?.success)
          window.location.replace('https://mlm-soft.com/demo/monarch_ui/production/admin-template/server-3.html');
        }
      }).catch(e => {
        console.log('e___2', e)
        console.log('e___2', e?.error)
      });
    },

    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && charCode < 48) || charCode > 57)
        evt.preventDefault();

    },

    processInputFloat(e) {
      let pressedKey = e.which,
          point = e.target.value.indexOf("."),
          keys = keyCodes.windows;

      // HACK for Chrome on Android (doesn't seem to work, though)
      if (pressedKey === keys["input busy"]) {
        e.preventDefault();
        return;
      }

      let allowedKeys = [
        keys["backspace"],
        keys["tab"],
        keys["enter"],
        keys["left arrow"],
        keys["right arrow"],
        keys["delete"],
        keys["period"],
        keys["num period"]
      ];

      // Decimal point already in value
      if (point !== -1) {
        allowedKeys.splice(allowedKeys.indexOf(keys["period"]), 1);
        allowedKeys.splice(allowedKeys.indexOf(keys["num period"]), 1);

        if (e.target.value.length > (point + 8) && this.selectionStart === this.selectionEnd &&
            (!allowedKeys.includes(pressedKey))) {
          // Allow only 2 decimal places, allow whitelisted keys after 2 decimal places reached
          e.preventDefault();
          return;
        }
      }

      if ((pressedKey < keys["0"] || pressedKey > keys["9"]) &&
          (pressedKey < keys["num 0"] || pressedKey > keys["num 9"]) &&
          (!allowedKeys.includes(pressedKey))) {
        // Allow only whitelisted (non-numeric) keys
        e.preventDefault();
      }
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '~vuetify/dist/vuetify.min.css';
@import '~bootstrap-vue/dist/bootstrap-vue.min.css';
@import '~bootstrap/dist/css/bootstrap.min.css';
@import "./../../styles/monarch/helpers/animate.css";
@import "./../../styles/monarch/helpers/boilerplate.css";
@import "./../../styles/monarch/helpers/border-radius.css";
@import "./../../styles/monarch/helpers/grid.css";
@import "./../../styles/monarch/helpers/utils.css";
@import "./../../styles/monarch/helpers/colors.css";
@import "./../../styles/monarch/elements/badges.css";
@import "./../../styles/monarch/elements/buttons.css";
@import "./../../styles/monarch/elements/content-box.css";
@import "./../../styles/monarch/elements/dashboard-box.css";
@import "./../../styles/monarch/elements/responsive-tables.css";
@import "./../../styles/monarch/widgets/modal/modal.css";
@import "./../../styles/monarch/snippets/user-profile.css";
@import "./../../styles/monarch/snippets/mobile-navigation.css";
@import "./../../styles/monarch/applications/mailbox.css";
@import "./../../styles/monarch/themes/admin/layout.css";
@import "./../../styles/monarch/themes/admin/color-schemes/default.css";
@import "./../../styles/monarch/themes/components/default.css";
@import "./../../styles/monarch/themes/components/border-radius.css";
@import "./../../styles/monarch/helpers/responsive-elements.css";
@import "./../../styles/monarch/helpers/admin-responsive.css";
@import "./../../styles/monarch/widgets/touchspin/touchspin.css";
@import "./../../styles/monarch/elements/forms.css";
@import "./../../styles/monarch/icons/fontawesome/fontawesome.css";
@import "assets/vue_snotify/material.css";

.company-logo {
  height:100px;
  background-position: center;
  background-size: contain;
}

label {
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif !important;
}

.btn-primary-custom{
  background: #00bca4;
}

.btn-primary-custom:hover {
  border-color: #00b19b;
  background-color: #00ceb4;
}

.password-switch{
  position:absolute; 
  display:block;
  z-index: 3;
  width: 30px;
  font-size: 17px;
  height:10px;
  top: 10px;
  right: 10px;
  cursor:pointer;
  outline: none;
}

.password-switch:hover{
  color: gray;
}


</style>
